import { createDefaultDialogForm } from './dialogConfig'

export const clampInteger = (value, fallback = '', min = 1, max = 31) => {
  const clean = String(value ?? '').replace(/[^\d]/g, '')
  if (!clean) return fallback
  const num = Number(clean)
  if (Number.isNaN(num)) return fallback
  const bounded = Math.min(max, Math.max(min, Math.floor(num)))
  return String(bounded)
}

export const normalizeDecimalInput = (value) => {
  return String(value ?? '')
    .replace(/[^\d.]/g, '')
    .replace(/\.(?=.*\.)/g, '')
}

export const isMinNightValid = (value, min = 1, max = 31) => {
  const text = String(value || '')
  return /^\d+$/.test(text) && Number(text) >= min && Number(text) <= max
}

export const buildDialogFormData = (formData = {}) => {
  const localForm = {
    ...createDefaultDialogForm(),
    ...formData,
    type: formData?.type || 'stay',
    roomTypeIds: Array.isArray(formData?.roomTypeIds) ? [...formData.roomTypeIds] : [],
    dateRange: Array.isArray(formData?.dateRange)
      ? [...formData.dateRange]
      : formData?.validFrom && formData?.validUntil
      ? [formData.validFrom, formData.validUntil]
      : formData?.startDate && formData?.endDate
      ? [formData.startDate, formData.endDate]
      : [],
  }

  const [startDate, endDate] = localForm.dateRange || []
  localForm.validFrom = startDate || null
  localForm.validUntil = endDate || null

  return localForm
}

export const buildSubmitPayload = (localForm = {}) => {
  const [startDate, endDate] = localForm.dateRange || []

  return {
    ...localForm,
    type: localForm.type,
    minNight: localForm.type === 'stay' ? Number(localForm.minNight) || 1 : null,
    value: Number(localForm.value) || 0,
    validFrom: localForm.type === 'period' ? startDate || null : null,
    validUntil: localForm.type === 'period' ? endDate || null : null,
    startDate: localForm.type === 'period' ? startDate || null : null,
    endDate: localForm.type === 'period' ? endDate || null : null,
    dateRange: localForm.type === 'period' ? localForm.dateRange : [],
    roomTypeIds: Array.isArray(localForm.roomTypeIds) ? [...localForm.roomTypeIds] : [],
  }
}
